import PropTypes from 'prop-types';

const languageShape = PropTypes.shape({
  id: PropTypes.string,
  abbr: PropTypes.string,
  label: PropTypes.string,
});

export default languageShape;
